// i18n
import { translateInComponent } from 'infras/i18n';
import translations from 'presentations/views/components/pages/AccountMenuPage/i18n.json';

import AccountMenuPage from 'presentations/views/components/pages/AccountMenuPage';
import MainDocument from 'presentations/views/components/MainDocument';

export default function Page() {
  const t = translateInComponent(translations);

  return (
    <MainDocument title={t('title')}>
      <AccountMenuPage />
    </MainDocument>
  );
}
